// extracted by mini-css-extract-plugin
export var avatarContainer = "_gu-0";
export var avatarTypingWave = "_gu-i";
export var gray = "_gu-f";
export var green = "_gu-c";
export var icon = "_gu-9";
export var image = "_gu-1";
export var lg = "_gu-6";
export var md = "_gu-5";
export var presenceDot = "_gu-b";
export var red = "_gu-d";
export var sm = "_gu-4";
export var status = "_gu-a";
export var typingDot = "_gu-h";
export var typingPill = "_gu-g";
export var xl = "_gu-7";
export var xs = "_gu-3";
export var xxl = "_gu-8";
export var xxs = "_gu-2";
export var yellow = "_gu-e";